const en = {
  translation: {
    externalCode: "Code",
    erpCode: "ERP code",
    barcode: "Barcode",
    aynaCode: "AYNA Code",
    swal: {
      confirmPasswordTitle: "Enter your password to confirm the operation",
      deleteReason: "Reason",
      success: "Operation was successfully completed",
      error: "An error occurred",
      edit: "Changes were applied",
      receipt: "Enter the receipt number to continue",
      cancelReason: "Cancel reason",
      reason: "Reason",
      lossPercentage: "Enter the loss percentage",
    },
    login: {
      email: "Email address",
      password: "Password",
      confirmPassword: "Confirm password",
      submit: "Login",
      chooseScale: "Choose Scale",
    },
    register: {
      default: "Register",
      authorizedPersonFirstName: "Authorized person's first name",
      authorizedPersonLastName: "Authorized person's last name",
      addOperatorCompanySuccess:
        "You have been successfully registered. Please, verify your registration by clicking on the link sent to your email address.",
      emailValidateSuccess:
        "Your registration has been successfully completed.",
      companyRegistration: "Company registration",
      operatorCompanyRegistration: "Operator company registration",
      userRegistration: "User registration",
      asterisk: "corresponds to required fields.",
      registerSuccess: "Your registration has been successfully completed.",
    },
    header: {
      profile: "Profile",
      changePassword: "Change password",
      logout: "Logout",
    },
    dashboard: {
      income: "Income",
      expense: "Expense",
      automaticScale: "Automatic scale",
      numberOfTrucks: "Number of trucks",
    },
    operation: {
      default: "Operation",
      plural: "Operations",
      type: "Operation type",
      completed: "Completed operation",
      net: "Net operation",
      date: "Operation date",
      weight1: "Weight 1",
      weight2: "Weight 2",
      weight1Date: "Weight 1 Date",
      weight2Date: "Weight 2 Date",
      receipt1: "Receipt",
      receipt2: "Receipt",
      aks: "AKS",
      aksList: "AKS list",
      aksPreview: "AKS view",
      aksType: "AKS type",
      username: "User",
      createDate: "Created date",
      preview: "Preview",
      image: "Image {{number}}", 
      removeAksTitle: "Delete AKS?",
      removeAksText: "AKS number {{number}} will be deleted.",
      confirm: "Enter your password to confirm your action",
      waitingIncomes: "Waiting incomes",
      waitingExpenses: "Waiting expenses",
      lossPercentage: "Loss percentage",
      lossPercentageEdit: "Loss percentage edit",
      lossPercentageDate: "Loss percentage date",
      lossPercentageAmount: "Loss amount",
      warehouse: "Warehouse",
      trailers: "Trailers",
      completeWithTechPass: "Complete with tech passport weight",
      divideCustomer: "Divide customer",
      divideSender: "Divide sender",
      dividedSum: "Divided sum",
      remainingSum: "Remaining sum",
      isDividedCustomer: "Operation has divided customers",
      isDividedSender: "Operation has divided senders",
      aynaStatus: "AYNA status",
      resendToAyna: "Resend to AYNA",
      sendToAyna: "Send to AYNA",
      sendingToAyna: "Sending...",
      downloadAynaDocument: "Download",
      aynaWaybill: "Goods transport waybill",
      aynaRoutebill: "Route sheet",
      aynaWaybillNumber: "Goods transport waybill number",
      aynaRoutebillNumber: "Route sheet number",
      downloadingAynaDocument: "Downloading...",
      aynaNotSent: "Not sent to AYNA",
      aynaDownloadPending: "Download API is not ready yet",
      aynaHistory: "History",
      aynaNumber: "AYNA number",
    },
    report: {
      default: "Report",
      rowsPerPage: "Rows per page",
      noChange: "No information about changes",
      all: "All reports",
      detailed: "Detailed report",
      sum: "Sum",
      weightNetWithoutLossPercentage: "Net w/o loss",
      CompletedWithoutWeight2Tara: "Only Tara reports",
      notApproveOperation: "Suspicious operation",
      suspiciousEmpty: "Suspicious empty",
      suspiciousFull: "Suspicious full",
    },
    trailer: {
      default: "Trailer",
      plural: "Trailers",
      numberPlate: "Number plate",
      supplier: "Trailer supplier",
      brand: "Trailer brand",
      model: "Trailer model",
      add: "ADD A NEW TRAILER",
      create: "Create a trailer",
      edit: "Edit the trailer",
      addToast: "Trailer was added",
      details: "Trailer details",
    },
    truck: {
      default: "Truck",
      numberPlate: "Number plate",
      owner: "Driver",
      brand: "Truck brand",
      model: "Truck model",
      emptyWeight: "Empty weight",
      emptyWeightHistory: "Empty weight history",
      clearEmptyWeight: "Reset empty weight history",
      confirmClearEmptyWeight: "Are you sure to reset empty weight?",
      emptyWeightDate: "Empty weight date",
      supplier: "Truck supplier",
      add: "ADD A NEW TRUCK",
      create: "Create a truck",
      edit: "Edit the truck",
      addToast: "Truck was added",
      details: "Truck details",
      type: "Truck type",
      technicalPassportNumber: "Tex passport number",
      technicalPassportWeight: "Tex passport weight",
      maxAllowedWeight: "Max weight",
      licenceNumber: "License number",
      licenceExpireDate: "License expiry date",
      licenceTypeName: "License type",
      axleCount: "Axle count",
      EmptyWeight1: 'Old empty weight',
      EmptyWeight2: 'New empty weight',
    },
    truckOwner: {
      default: "Driver",
      name: "Driver name",
      surname: "Driver surname",
      fin: "FIN",
      supplier: "Driver supplier",
      driverLicenseNumber: "Driver license number",
      driverLicenseExpiryDate: "Driver license expiry date",
      add: "ADD A NEW DRIVER",
      create: "Create a driver",
      edit: "Edit the driver",
      addToast: "Driver was added",
      details: "Driver details",
    },
    cargo: {
      default: "Cargo",
      name: "Cargo name",
      type: "Cargo type",
      note: "Cargo note",
      unitOfMeasure: "Unit of measure",
      price: "Price",
      contractNumber: "Contract row number",
      numMeasurementUnit: "Number unit",
      massMeasurementUnit: "Mass unit",
      add: "ADD A NEW CARGO",
      create: "Create a cargo",
      edit: "Edit the cargo",
      addToast: "Cargo was added",
      details: "Cargo details",
    },
    cargoType: {
      default: "Cargo type",
      add: "ADD A NEW CARGO TYPE",
      create: "Create a cargo type",
      edit: "Edit the cargo type",
      addToast: "Cargo type was added",
    },
    deliveryType: {
      default: "Delivery type",
      add: "ADD A NEW DELIVERY TYPE",
      create: "Create a delivery type",
      edit: "Edit the delivery type",
      addToast: "Delivery type was added",
    },
    orderPartStep: {
      label: "Step status",
    },
    orderPartStepCompany: {
      label: "Step status",
      qr: "QR-code data",
    },
    subCargo: {
      default: "Subcargo",
      name: "Subcargo name",
      type: "Subcargo type",
      note: "Subcargo note",
      add: "ADD A NEW SUBCARGO",
      create: "Create a subcargo",
      edit: "Edit the subcargo",
      addToast: "Subcargo was added",
      details: "Subcargo details",
    },
    company: {
      default: "Company",
      type: "Company type",
      operatorCompany: "Operator company",
      name: "Company name",
      usageEnvironment: "Usage environment",
      licenseStartDate: "License start date",
      licenseEndDate: "License end date",
      calibrationStartDate: "Calibration start date",
      nextCalibrationDate: "Next calibration date",
      voen: "VOEN",
      camera: "Camera",
      qrCode: "QR code",
      printForm: "Print form",
      founderTelegramNumber: "Founder telegram number",
      add: "ADD A NEW COMPANY",
      create: "Create a company",
      edit: "Edit the company",
      addToast: "Company was added",
      approveOperatorCompany:
        "Are you sure you want to approve the operator company?",
      rejectOperatorCompany: "Reject company?",
      createTelegramChannel: "Create Telegram channel",
      deleteMessage:
        "All the users related to this company will be deleted. Are you sure?",
      details: "Company details",
      ip: "IP address",
      operationDivideAvailable: "Operation division available",
      netPoolAvailable: "Net Pool",
      aynaSyncAvailable: "AYNA Integration",
      notApproveOperationCheckHour: "Suspicious operation hour",
      aiExist: "AI exists",
      aiType: "AI type",
      aiToken: "AI Token",
      aiSettings: "AI settings",
    },
    companyAllowedIpAddress: {
      addToast: "IP address was added",
      add: "ADD A NEW IP ADDRESS",
      create: "Add an IP address",
      edit: "Edit the IP address",
    },
    scaleCamera: {
      addToast: "Camera was added",
      add: "ADD A NEW CAMERA",
      create: "Add a camera",
      edit: "Edit the camera",
      name: "Camera name",
      url: "Camera URL",
    },
    senderWarehouseConfig: {
      addToast: "Config was added",
      add: "ADD A NEW CONFIG",
      create: "Add a config",
      edit: "Edit the config",
    },
    customer: {
      default: "Customer",
      name: "Customer name",
      distance: "Distance",
      voen: "VOEN",
      add: "ADD A NEW CUSTOMER",
      create: "Create a customer",
      edit: "Edit the customer",
      addToast: "Customer was added",
      details: "Customer details",
      zipCode: "Zip code",
    },
    customerBranch: {
      default: "Customer branch",
      name: "Customer branch name",
      plural: "Customer or supplier branches",
      add: "ADD A NEW CUSTOMER BRANCH",
      create: "Create a customer branch",
      edit: "Edit the customer branch",
      addToast: "Customer branch was added",
      details: "Customer branch details",
      back: "Back to customer branches",
    },
    customerWarehouse: {
      default: "Customer warehouse",
      name: "Customer warehouse name",
      add: "ADD A NEW CUSTOMER WAREHOUSE",
      create: "Create a customer warehouse",
      edit: "Edit the customer warehouse",
      addToast: "Customer warehouse was added",
      details: "Customer warehouse details",
    },
    senderWarehouse: {
      default: "Sender warehouse",
      name: "Sender warehouse name",
      add: "ADD A NEW SENDER WAREHOUSE",
      create: "Create a sender warehouse",
      edit: "Edit the sender warehouse",
      addToast: "Sender warehouse was added",
      details: "Sender warehouse details",
    },
    supplier: {
      default: "Supplier",
      name: "Supplier name",
      branch: "Supplier branch",
    },
    sender: {
      default: "Sender",
      name: "Sender name",
      voen: "VOEN",
      add: "ADD A NEW SENDER",
      create: "Create a sender",
      edit: "Edit the sender",
      addToast: "Sender was added",
      details: "Sender details",
    },
    senderBranch: {
      default: "Sender branch",
      name: "Sender name",
      plural: "Sender branches",
      add: "ADD A NEW SENDER BRANCH",
      create: "Create a sender branch",
      edit: "Edit the sender branch",
      addToast: "Sender branch was added",
      details: "Sender branch details",
      back: "Back to sender branches",
    },
    companyBranch: {
      default: "Company branch",
      name: "Company branch name",
      plural: "Company branches",
      add: "ADD A NEW COMPANY BRANCH",
      create: "Create a company branch",
      edit: "Edit the company branch",
      addToast: "Company branch was added",
      details: "Company branch details",
      back: "Back to company branches",
    },
    scale: {
      default: "Scale",
      name: "Scale name",
      add: "ADD A NEW SCALE",
      create: "Create a scale",
      edit: "Edit the scale",
      addScaleCard: "Add Scale Card",
      updateScaleCard: "Update Scale Card",
      addToast: "Scale was added",
      expectedValue: "Expected value",
      details: "Scale details",
      weight2CanChange: "Weight 2 change",
      IsAks: "Axle mode",
      qrScale: "QR code scale",
      construction: "Construction",
      kind: 'Kind',
      type: 'Type',
      brand: 'Scale Brand',
      model: 'Scale Model',
      bodyLength: 'Body Length',
      bodyWidth: 'Body Width',
      loadcellNumber: 'Loadcell Number',
      loadcellBrand: 'Loadcell Brand',
      loadcellModel: 'Loadcell Model',
      loadCellCableType: 'Loadcell Cable Type',
      loadCellCableLength: 'Loadcell Cable Length',
      indicatorBrand: 'IndicatorBrand',
      indicatorModel: 'Indicator Model',
      walkingStep: 'Walking Step',
      junctionBoxBrand: 'Junction Box Brand',
      junctionBoxModel: 'Junction Box Model',
      maximumWeight: 'Maximum Weight',
      minimumWeight: 'Minimum Weight',
      images: 'Scale Images',
      aiChecking: 'AI Checking',
    },
    serviceCard: {
      add: 'Add Service Card',
      update: 'Update Service Card',
      kind: 'Service Kind',
      part: 'Serviced Part',
      customer: 'Customer',
      person: 'Service Perform Person',
      problem: 'Detected problem',
      problemSolution: 'Problem Result',
      createdUser: 'Created User',
      code: 'Code',
      files: 'Files',
      serviceDate: 'Service Date'
    },
    order: {
      default: "Order",
      plural: "Orders",
      add: "CREATE A NEW ORDER",
      addToast: "Order was created",
      hasOperation: "Used by operation",
      isCompleted: "Completed",
      details: "Order details",
      id: "Order number",
      creditType: "Credit limit",
      typeWeightLimit: "Limit",
    },
    orderPart: {
      default: "Order part",
      plural: "Order parts",
      add: "ADD A NEW ORDER PART",
      create: "Create an order part",
      edit: "Edit the order part",
      addToast: "Order part was added",
      editStep: "Step status updated",
      details: "Order part details",
      log: "Order part log",
      logonOrderNo:"ERP integration code"
    },
    logonRequest: {
      details: "Logon Request Details",
    },
    subOrders: {
      default: "Sub Order",
      plural: "Sub Orders",
      add: "CREATE NEW SUB ORDER",
      create: "Create New Sub Order",
      edit: "Edit the sub order",
      addToast: "Sub Order created",
      details: "Sub Order Details",
      ID: "Id",
      PreviousVolume: "Previous Volume  (kg)",
      RemainingVolume: "Remaining Volume (kg)",
      IsCompleted: "Is Completed",
      SubOrderType: "Sub Order Type",
      CreateDate: "Create Date",
    },
    truckType: {
      default: "Truck type",
      add: "ADD A NEW TRUCK TYPE",
      create: "Create a truck type",
      edit: "Edit the truck type",
      addToast: "Truck type was added",
    },
    carBrand: {
      default: "Car brand",
      name: "Car brand name",
      add: "ADD A NEW CAR BRAND",
      create: "Create a car brand",
      edit: "Edit the car brand",
      addToast: "Car brand was added",
    },
    carModel: {
      default: "Car model",
      name: "Car model name",
      add: "ADD A NEW CAR MODEL",
      create: "Create a car model",
      edit: "Edit the car model",
      addToast: "Car model was added",
    },
    camera: {
      default: "Camera",
      url: "Camera URL",
      ContinueCameraError: "Continue even if there is a camera error",
      errors: "Camera errors",
      errorType: "Error type",
      weightError: "Weight error",
      SensorInputForOperation: "Sensor Input For Operation",
      Cargo2WeightOnNetWeight: "Deducting the weight of the secondary cargo from the total weight"
    },
    automaticScale: {
      default: "Automatic scale",
      startTime: "Start time",
      minWeight: "Minimum weight",
    },
    status: {
      default: "Status",
    },
    date: {
      default: "Date",
      start: "Start date",
      end: "End date",
      createdAt: "Created at",
      installationDate: "Installation Date"
    },
    time: {
      default: "Time",
      difference: "Time difference",
      years: "year",
      months: "month",
      days: "day",
      hours: "hour",
      minutes: "minute",
      seconds: "second",
      milliseconds: "millisecond",
    },
    actions: {
      default: "Actions",
      single: "Action",
      taken: "Taken by",
    },
    image: {
      default: "Image",
    },
    buttons: {
      filter: "FILTER",
      search: "Search",
      reset: "Reset",
      export: "Export",
      print: "Print",
      columns: "Columns",
      today: "Today",
      groups: "Groups",
      save: "Save",
      confirm: "Confirm",
      cancel: "Cancel",
      delete: "Delete",
      decide: "Decide",
      back: "Back",
      next: "Next",
      emptyWeight: 'Approve empty weight'
    },
    inputs: {
      select: "Select",
    },
    checks: {
      printImages: "Print images",
    },
    errors: {
      noData: "No data found",
      noOperationPermission: "You do not have permission to weigh",
      noChangeInfo: "No information about changes",
      noRfidCard: "No information in the card",
      noRfidCardOperation: "No operation in the card",
      noWeight: "Weight could not be measured",
      minWeight: "Weight is less than the minimum permitted weight",
      noCustomer: "No customer added with this VOEN",
      customerNotFound: "Customer not found",
      truckNotFound: "Truck not found",
      senderNotFound: "Sender not found",
      customerBranchNotFound: "Customer branch not found",
      noSender: "No sender added with this VOEN",
      senderBranchNotFound: "Sender branch not found",
      companyBranchNotFound: "Company branch not found",
      fillInGaps: "Fill in the gaps",
      noCargo: "No cargo added with this name",
      cargoNotFound: "Cargo not found",
      noWeight1: "Weight 1 cannot be empty. Please, refresh the page.",
      noWeight2: "Weight 2 cannot be empty. Please, refresh the page.",
      dividedSumGtThanNet: "Divided sum cannot be greater than net weight.",
      emptyWeight:
        "The vehicle you selected could not be changed because it does not have the curb weight.",
      technicalPassportWeight:
        "It was not possible to change the vehicle because the vehicle you selected does not have the Tech passport weight.",
      technicalTrailerPassportWeight:
        "It was not possible to change the trailer because the trailer you selected does not have the Tech passport weight.",
    },
    errorPage: {
      code: "Error code: {{code}}",
      notFoundTitle: "The page could not be found",
      notFoundDescription:
        "The link may have been removed, changed, or entered incorrectly.",
      errorTitle: "An unexpected error occurred",
      errorDescription:
        "Reload the page. If the problem continues, contact the system administrator.",
      home: "Home page",
      back: "Go back",
      tryAgain: "Try again",
      help: "If the problem repeats, report the error code to the administrator.",
    },
    utils: {
      and: "and",
      weight: "weight",
      full: "full",
      empty: "empty",
      count: "count",
      yes: "yes",
      no: "no",
      ok: "OK",
      type: "type",
      add: "add",
      create: "create",
      edit: "edit",
      update: "update",
      created: "Created by",
      name: "name",
      eg: "e.g.",
      calibration: "Calibration",
      note: "Note",
      green: "Green",
      red: "Red",
      kg: "kg",
      id: "ID card number",
      birthDate: "Birth date",
      area: "Area",
      district: "District",
      country: "Country",
      authorizedPerson: "Authorized person",
      volume: "Volume (kg)",
      remainingVolume: "Remaining volume (kg)",
      completedVolume: "Completed volume (kg)",
      file: "File",
      downloadExample: "Download example",
      isApproved: "Approved?",
      netDifference: "Net difference",
      day: "day",
      days: "days",
      branch: "Branch",
      warehouse: "Warehouse",
      refresh: "Refresh",
      active: "Active",
      deactive: "Deactive",
    },
    modal: {
      close: "Close",
      sure: "Are you sure?",
    },
    mapPicker: {
      title: "Select pin on map",
      openButton: "Pick pin on map",
      missingApiKey:
        "Google Maps API key is not configured.",
      loadError: "Map could not be loaded. Please try again later.",
    },
    operator: {
      signature: "Operator's signature",
      note: "Operator's note",
      name: "Operator's name",
    },
    admin: {
      note: "Admin's note",
    },
    logon: {
      chooseTruck: "Choose Truck",
    },
    aiAnalyze: {
      color: 'Color',
      make: 'Make',
      model: 'Model',
      plateNumber: 'Plate Number',
      image: 'Image',
      apply: 'Apply'
    },
    nav: {
      aiAnalyze: "AI Analyze",
      dashboard: "Dashboard",
      incomes: "Incomes",
      reports: {
        default: "Reports",
        sum: "Sum",
        summReporter: "Summ Reporter",
        groupSum: "Group Sum",
        dividedSum: "Divided sum",
      },
      orders: "Orders",
      subOrders: "Sub Orders",
      orderParts: "Order parts",
      logonRequests: "Logon requests",
      new: {
        order: "Order",
        default: "New",
        customer: "Customer or supplier",
        customerBranches: "Customer or supplier branches",
        customerWarehouse: "Customer warehouse",
        senderWarehouse: "Sender warehouse",
        senderBranches: "Sender branches",
        companyBranches: "Company branches",
        cargo: "Cargo",
        cargoType: "Cargo type",
        subCargo: "Subcargo",
        truckOwner: "Driver",
        truck: "Truck",
        trailer: "Trailer",
        sender: "Sender",
        truckType: "Truck types",
        carBrands: "Car brands",
        carModels: "Car models",
        deliveryTypes: "Delivery types",
        companyAllowedIpAddress: "Company IP addresses",
        scaleCamera: "Cameras",
        senderWarehouseConfig: "Sender warehouse config",
      },
      requests: {
        default: "Requests",
        completed: "Completed",
        waiting: "Waiting",
        approved: "Approved incomes",
        cancelled: "Cancelled incomes",
      },
      lpi: {
        reset: "Reset",
        default: "LPI",
        ipAddress: "LPI IP address",
        port: "LPI port",
        history: "LPI history",
        statusHistory: "Status history",
        calibrationHistory: "Calibration history",
        realWeight: "Real weight",
        enteredWeight: "Entered weight",
        calibrate: "Calibrate",
        deviceOperations: "Operations on device buttons",
        calibrationStatus: "Calibration status",
        lock: "Lock",
        unlock: "Unlock",
        calibrationActive: "Calibration is active",
        activateCalibration: "Activate calibration",
        calibrationWarning:
          "Empty the scale, make sure the scale is fully empty.",
        enterCalibrationValue: "Enter calibration value",
        lpiCalibrate: "Calibrate LPI",
      },
      history: "History",
      importData: "Import data",
      companies: "Companies",
      companiesQr: "Companies QR-code",
      scales: "Scales",
      rfidCards: "RFID cards",
      rfidCardOperations: "RFID card operations",
      users: "Users",
      logout: "Logout",
      scaleCard: 'Scale Cards',
      serviceCard: 'Service Cards'
    },
    user: {
      username: "Username",
      oldPassword: "Old password",
      newPassword: "New password",
      changePassword: "Change password",
      resetPassword: "Reset password",
      phone: "Phone",
      address: "Address",
      latitude: "Latitude",
      longitude: "Longitude",
      role: "User role",
      add: "ADD A NEW USER",
      create: "Create a user",
      edit: "Edit the user",
      addToast: "User was added",
      resendMailConfirm: "Resend email?",
      approveUserConfirm: "Approve user?",
      invite: "INVITE A USER",
      fullname: "Full name",
      resendApproveMail: "Resend approve mail",
      resendInviteMail: "Resend invite mail",
      deleteCurrentImage: "Delete current image?",
      details: "User details",
      operatorPermission: "Allowed day count",
      guardType: "Guard type",
      canWriteLossPercentage: "Can write loss percentage?",
      lossPercentageAvailable: "Loss percentage?",
      canShowNewMenu: "Can see New menu",
      canShowOperation: "Can see operation buttons",
      canShowOrderPart: "Can see order parts",
      canShowReport: "Can see reports",
      canShowOrderPartCompleted: "Can see completed order parts",
      isDispetcher: "Dispatcher?",
      mustChangePassAtNextLogin: "Must change password",
      canDivideOperation: "Can divide operations",
      aynaSyncAvailable: "AYNA Sync Available",
    },
    rfidCard: {
      rfidNumber: "RFID number",
      cardNumber: "Card number",
      cardType: "Card type",
      operation: "Operation",
      operations: "Card operations",
      history: "Card history",
      add: "ADD A NEW RFID CARD",
      create: "Create a RFID card",
      edit: "Edit the RFID card",
      reset: "Are you sure you want to reset the card?",
      delete: "Are you sure you want to delete the card?",
      resetButton: "Reset",
      addToast: "RFID card was added",
      addOperationToast: "RFID card operation was created",
    },
    request: {
      changeInfo: "Information about changes",
      deleteInfo: "Information about deletion",
      fieldName: "Field name",
      oldValue: "Old value",
      newValue: "New value",
      user: "User",
      history: "History",
      requestEdit: "Do you confirm the applied changes?",
      requestDelete: "Do you confirm the deletion?",
      confirm: "Confirm",
      deny: "Deny",
    },
    history: {
      tableName: "Table name",
    },
    regex: {
      required: "This field is required",
      number: "This field must have only numbers",
      positiveNumber: "Number must be positive",
      min3: "This field must have at least 3 characters",
      min5: "This field must have at least 5 characters",
      length10: "This field must have 10 characters",
      password:
        "Password must have at least 6 characters, at least 1 uppercase letter, 1 lowercase letter, and 1 digit",
      confirmPassword: "Passwords do not match",
      email: "Please, enter a valid email address",
      phone: "Please, enter a valid phone number",
      telegram: "Please, enter a valid telegram number",
      numberPlate: "Please, enter a valid number plate",
      branchCode: "Branch code format must be 1234567890-12345",
      emptyWeight: "Number must be positive and have at most 2 decimal places",
      customerType: "Type is required",
      coordinateNumber: "Coordinate must be a valid number",
      latitudeRange: "Latitude must be between -90 and 90",
      longitudeRange: "Longitude must be between -180 and 180",
      coordinatePair: "Latitude and Longitude must be filled together",
      numberPlateExists: "This truck already exists",
    },
    calibrationExpired:
      "The calibration date of the company has been expired. Calibration date was {{date}}.",
    calibrationNext:
      "The calibration date of the company is {{date}}. {{days}} days left until the next calibration date of the company.",
    netDifference: "Net difference: {{NetDifference}}",
    continueWithEmptyWeight:
      "Truck has an empty weight. Continue with empty weight?",
    copyright: "All rights reserved",
    incomeOperation: {
      approve: "Approve",
      cancel: "Cancel",
      detailed: "Details",
    },
    print3: {
      organizationName: "Customer",
      entranceDate: "Entrance date",
      exitDate: "Exit date",
      entranceTime: "Entrance time",
      exitTime: "Exit time",
      kontragent: "Sender",
    },
  },
};

export default en;
